import { render, staticRenderFns } from "./CreateSectionForm.vue?vue&type=template&id=16e6164b&"
import script from "./CreateSectionForm.vue?vue&type=script&lang=ts&"
export * from "./CreateSectionForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports